import React, { useCallback, useLayoutEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { beginLaunchTelemetry, failLaunch, finishLaunch } from '../../../services/launch-telemetry';
import { ErrorPage } from '../../global/error-page';
import { setHtmlAttributes } from '../../../helpers';
import { LaunchErrorCodes } from '../../../enums';
import { useQuery, useStore } from '../../../hooks';

interface SplashProps {
  children: React.ReactNode;
}

export const Splash: React.FC<SplashProps> = observer(({ children }) => {
  const { query } = useQuery();
  const { gameStore } = useStore();
  const { launchData: { isLoading }, relaunchBlocked } = gameStore;

  useLayoutEffect(() => {
    setHtmlAttributes('en'); // todo
    init();
  }, []);

  const init = useCallback(async () => {
    const { launchToken, launchError } = query;
    beginLaunchTelemetry(query);
    if (launchError) {
      // Backend could not store the launch payload (RedirectWithModelResult): nothing to redeem, so re-run the
      // launch through the operator URL exactly as a token miss does. Recorded first so the attempt is counted.
      failLaunch('redirect', String(launchError));
      finishLaunch('error');
      gameStore.relaunchOrBlock();
      return;
    }
    gameStore.getLaunchData(launchToken);
  }, [query]);

  // The relaunch cooldown suppressed our only exit; GENERAL_ERROR is what ErrorPage keys its retry button on.
  if (relaunchBlocked) return <ErrorPage errorCode={LaunchErrorCodes.GENERAL_ERROR} />;

  return (
    <>
      {/* note: instaed of null you can render neutral loading state */}
      { isLoading ? null : children }
    </>
  );
});
